const TYPES = {
    WEB3_INIT: "web3-init",
    WEB3_CLEAR: "web3-clear",
    UPDATE_CONNECTED_ADDRESS: "update-connected-address",
    UPDATE_CHAIN_AND_NETWORK_ID: "update-chain-and-network-id",
}

export default TYPES;